import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';

@Component({
  selector: 'sbnb-direct-site-type-card',
  templateUrl: './direct-site-type-card.component.html',
})
export class DirectSiteTypeCardComponent {
  @Input() config: {
    title: string;
    time?: string;
    list: {
      hideIcon?: boolean;
      text: string;
    }[];
  };
  @Input() isLoading = false;
  @Input() isDisabled = false;
  @Output() clicked = new EventEmitter<void>();
  isMobile$ = this.deviceDetectionService.isMobileViewport();

  constructor(private deviceDetectionService: DeviceDetectionService) {}

  handleClick(): void {
    if (this.isLoading || this.isDisabled) return;
    this.clicked.emit();
  }
}
